// extracted by mini-css-extract-plugin
export default {"pagination":"secondary-button_pagination__ijTzR","page-link":"secondary-button_page-link__Q34xL","button":"secondary-button_button__q6V0Q"};